export const VALIDATE_EMAIL = 'v2/users/validation/email';
export const CONFIRM_EMAIL = 'v2/users/validation/email/confirm';